<template>
	<div class="add_backimg add_backimgTop clearfix">
		<div class="nav_list">
			<span class="primaryColor"><i class="el-icon-location-outline"></i>当前位置：</span>
			<span class="pointer" @click="toName('index')">首页<i class="el-icon-arrow-right"></i></span>
			<span class="pointer" @click="toBack(labInfo.typeId)">虚拟仿真<i class="el-icon-arrow-right"></i></span>
			<span>仿真实验详情</span>
		</div>
		<div class="lab_cont clearfix">
			<img src="@/images/lab_back.png" class="lab_back" />
			<div class="lab_cover">
				<img :src="baseurl + labInfo.cover" v-if="labInfo.cover" />
			</div>
			<div class="lab_contType">{{labInfo.typeName}}</div>
			<div class="lab_titleInfo text-ellipsis">
				<span>【{{labInfo.mode == '3'?'训练':'考核'}}】{{labInfo.name}}</span>
			</div>
			<div class="lab_desc">
				<div class="lab_start">
					<el-rate v-model="labInfo.averageScore || 5" disabled show-score text-color="#ff9900" score-template="{value}">
					</el-rate>
				</div>
				<span class="lab_stand"></span>
				<div class="lab_start">{{labInfo.clicks || 0}}人已浏览</div>
				<span class="lab_stand"></span>
				<div class="lab_start">{{labInfo.collectionCount || 0}}人已收藏</div>
			</div>
			<div class="lab_infoBox">
				<div class="lab_infoIcon">
					<img src="@/images/lab_infoBack.png" />
					<span>实验目的</span>
				</div>
				<div class="lab_infoText lab_infoTextMore text-ellipsistwo">
					{{labInfo.introduction || '无'}}
					<div @click="infoOpen = true" class="lab_infoTextMorebtn">更多</div>
				</div>
			</div>
			<div class="lab_get">
				<div class="lab_getTime">
					已操作<span class="successColor"> {{labInfo.clickNum || 0}} </span>次
				</div>
				<div class="lab_getBtns clearfix">
					<div class="lab_getBox">
						<el-button type='warning' @click="viewSimulation(labInfo)" v-if="labInfo.mode == '3'">进入训练</el-button>
						<el-button type='primary' @click="viewSimulation(labInfo)"  v-if="labInfo.mode == '2'" :disabled='labInfo.vrExamineState != 1' >进入考核</el-button>
					</div>
					<div class="lab_setBox clearfix">
						<div class="lab_setBoxItem" v-show="!starIng">您已打分：</div>
						<div class="lab_setBoxItem" v-show="starIng">为本实验打分：</div>
						<div class="lab_setBoxItem lab_setBoxStar" v-show="!starIng">
							<el-rate v-model="labInfo.mystar" :disabled='true' show-score text-color="#ff9900" score-template="{value}">
							</el-rate>
						</div>
						<div class="lab_setBoxItem lab_setBoxStar" v-show="starIng">
							<el-rate v-model="labInfo.newstar" @change='changeStar()' show-score text-color="#ff9900" score-template="{value}">
							</el-rate>
						</div>
						<div class="lab_setBoxItem lab_setBoxRe" v-if="!hasStared && !starIng">
							<img src="@/images/re_start.png" @click="starIng = true" />
						</div>
						<img @click="simulationCollection(labInfo)" title="取消收藏" class="lab_titleInfoimg" src="@/images/course_collect2.png" v-if="labInfo.isCollection" />
						<img @click="simulationCollection(labInfo)" title="实验收藏" class="lab_titleInfoimg" src="@/images/course_collect1.png" v-if="!labInfo.isCollection" />
					</div>
				</div>
			</div>
		</div>
		<div class="course_contBottom clearfix" ref='contBottom'>
			<div class="course_bottomMenus">
				<div class="course_bottomMenu lab_bottomMenu" :class="showindex == item.id?'active':''" @click="showindex = item.id" v-for='(item,index) in navList' v-if='!item.hidden'>
					<img :src="item.activeIcon" class="activeIcon" />
					<img :src="item.icon" class="normalIcon" />
					<el-badge :is-dot='item.isDot'>
						<div class="course_menuText">
							{{item.name}}
							<span class="course_bottomInfo">{{index == 2 && commontTotal?'('+commontTotal+')':''}}</span>
						</div>
					</el-badge>
				</div>
			</div>
			<lab-info v-if="showindex == 'info'" :vrDetailId="vrDetailId" :resourceId='resourceId'>
			</lab-info>
			<lab-task v-if="showindex == 'task'" :vrDetailId="vrDetailId">
			</lab-task>
			<lab-commont v-if="showindex == 'commont'" :vrDetailId="vrDetailId" @commentAdd='getCommentList'>
			</lab-commont>
			<lab-statistical v-if="showindex == 'statistical' && labInfo.vrResourceExamine" :vrDetailId="vrDetailId" :resourceId="labInfo.vrResourceExamine.id">
			</lab-statistical>
		</div>
		<el-dialog title="实验目的" class="open_dialogInfo" :visible.sync="infoOpen" :append-to-body='true' width="900px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<div class="dialog_message dialog_messageText beautifulScroll">
				<div v-html='labInfo.introductionHtml'></div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { getStorageToken, heightToTop } from '@/utils/auth.js'
	import { vrcommentList } from '@/api/comment.js'
	import { vrPaperUserInit, clickInsert, saveResourceScore, removeResourceScore, getResourceScore, getResourceDetail, getResourceDetailClicks, userIsCollection, getResourceDetailRecord, saveResourceDetailRecord, userCollectionSave, userCollectionRemove } from '@/api/simulation.js'
	import labInfo from '@/views/fictitious/components/labInfo.vue'
	import labTask from '@/views/fictitious/components/labTask.vue'
	import labCommont from '@/views/fictitious/components/labCommont.vue'
	import labStatistical from '@/views/fictitious/components/labStatistical.vue'
	export default {
		components: {
			labInfo,
			labTask,
			labCommont,
			labStatistical
		},
		data() {
			return {
				vrDetailId: this.$route.query.vrDetailId,
				resourceId: this.$route.query.resourceId,
				toTab: this.$route.query.toTab,
				labInfo: {},
				commontTotal: 0,
				starIng: false,
				infoOpen: false,
				hasStared: true,
				firstnav: true,
				navList: [{
					isDot: false,
					num: 0,
					name: '实验介绍',
					id: 'info',
					activeIcon: require('@/images/lab_nav1A.png'),
					icon: require('@/images/lab_nav1.png'),
				}, {
					isDot: false,
					num: 0,
					name: '实验作业',
					id: 'task',
					activeIcon: require('@/images/lab_nav2A.png'),
					icon: require('@/images/lab_nav2.png')
				}, {
					isDot: false,
					num: 58,
					name: '实验讨论',
					id: 'commont',
					activeIcon: require('@/images/lab_nav3A.png'),
					icon: require('@/images/lab_nav3.png')
				}, {
					hidden: true,
					isDot: false,
					num: 0,
					name: '实验统计',
					id: 'statistical',
					activeIcon: require('@/images/lab_nav4A.png'),
					icon: require('@/images/lab_nav4.png')
				}],
				showindex: 'info',
			}
		},
		created() {
			this.getCommentList();
			this.clickInsert();
		},
		mounted() {
			this.$nextTick(() => {
				if(this.toTab) {
					this.toActiveTab(this.toTab)
				}
			})
		},
		methods: {
			getCommentList() {
				var data = {
					limit: 1,
					current: 1,
					vrDetailId: this.vrDetailId,
				}
				vrcommentList(data).then(res => {
					if(res.code == "OK") {
						this.commontTotal = res.data.total;
					}
				})
			},
			clickInsert() {
				clickInsert({
					vrDetailId: this.vrDetailId,
					resourceId: this.resourceId,
				}).then(res => {
					this.getResourceDetail();
				})
			},
			getResourceDetail() {
				getResourceDetail({
					vrDetailId: this.vrDetailId,
					resourceId: this.resourceId,
				}).then(res => {
					this.labInfo = res.data || {};
					if(this.labInfo.version == '2.0.0') {
						this.navList[3].hidden = false
					} else {
						this.navList[3].hidden = true
					}
					this.userIsCollection();
					this.getResourceDetailRecord();
					this.getResourceScore();
				})
			},
			userIsCollection() {
				userIsCollection({
					id: this.resourceId,
				}).then(res => {
					this.labInfo = Object.assign({}, this.labInfo, {
						isCollection: res.data || false
					})
				})
			},
			getResourceDetailRecord() {
				getResourceDetailRecord({
					vrDetailId: this.vrDetailId,
					resourceId: this.resourceId,
				}).then(res => {
					this.labInfo = Object.assign({}, this.labInfo, {
						clickNum: res.data ? res.data : 0
					})
				})
			},
			getResourceScore() {
				getResourceScore({
					vrDetailId: this.vrDetailId,
					resourceId: this.resourceId,
				}).then(res => {
					this.labInfo = Object.assign({}, this.labInfo, {
						mystar: res.data ? res.data : 0,
						newstar: 0,
					})
					if(!res.data) {
						this.starIng = true;
						this.hasStared = true;
					} else {
						this.starIng = false;
						this.hasStared = false;
					}
				})
			},
			changeStar() {
				var data = {
					vrDetailId: this.vrDetailId,
					resourceId: this.resourceId,
					score: this.labInfo.newstar
				}
				saveResourceScore(data).then(res => {
					this.getResourceDetail()
				})
			},
			viewSimulation(item) {
				var vrDetailId = item.id;
				var resourceId = item.resourceId;
				var token = getStorageToken();
				if(token) {
					saveResourceDetailRecord({
						vrDetailId: vrDetailId,
						resourceId: resourceId,
					}).then(res => {
						this.getResourceDetailRecord();
						if(item.mode && item.mode == '2') {
							if(item.version == '2.0.0') {
								window.open('#/fictitiousdetail?type=exam&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId)
							} else {
								vrPaperUserInit({
									vrDetailId: vrDetailId,
									resourceId: resourceId,
									expertype: item.typeId,
								}).then(res => { //判断是否有关联的试卷，存在则直接返回，不存在则创建后返回
									if(res.code == 'OK') {
										window.open('#/fictitiousdetail?type=index&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId + '&pid=' + res.data)
									}
								})
							}
						} else {
							window.open('#/fictitiousdetail?type=test&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId)
						}
					})
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			simulationCollection(item) {
				var token = getStorageToken();
				if(token) {
					if(!item.isCollection) {
						userCollectionSave({
							vrDetailId: item.id,
							resourceId: item.resourceId,
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: "收藏成功!",
								})
								this.getResourceDetail()
							} else {
								this.$message({
									type: 'error',
									message: res.data.message,
								})
							}
						})
					} else {
						userCollectionRemove({
							vrDetailId: item.id,
							resourceId: item.resourceId,
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: '取消成功!'
								});
								this.getResourceDetail()
							}
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			toActiveTab(showindex) {
				this.showindex = showindex;
				var height = heightToTop(this.$refs.contBottom);
				$("html").animate({
					scrollTop: height
				}, 300);
			},
			toName(name) {
				if(this.$router.name != name) {
					this.$router.push({
						name: name
					})
				}
			},
			toBack(typeId) {
				this.$router.push({
					name: 'fictitious',
					query: {
						typeId: typeId
					}
				})
			},
		},
	}
</script>